<template>
  <div class="card-deck">
    <Documents :posts="posts" :translate="translate" />
  </div>
</template>

<script setup>
  import { useTranslationStore } from '@/stores/translations'
  const translationStore = useTranslationStore()
  const translate = translationStore.translate


const props = defineProps({
  cardDeck: {
    type: String,
    default: "",
  },
  posts: {
    type: Object,
    required: true,
  },
});

// Dynamically import the Download component
const Documents = defineAsyncComponent(() =>
  import(`@/components/apps/card/Document.vue`)
);
</script>
